import { useEffect, useRef, useState } from "react";
import { Checkbox } from "@rmwc/checkbox";
import { Select } from "@rmwc/select";
import { useDispatch, useSelector } from "react-redux";
import { getSelectedTabstate, onSubmitState, confirmStateAction, setZipCodeVal, zipCodeError, showStateField, handleCompanySelection, savePriceComparisionDataForNotLoggedIn } from "../../../action/index.js";
import { stateManufacturerChange } from "../../../action/manufacturers_auth/manufacture.action.js";
import { onSubmit, setThankYouForSaveLaterValue } from "../../../action/quote_order/quote.action.js";
import * as validate from "../../Modals/validations";
import { getManufactureDetails } from "../../../action/manufacturers_auth/login.action.js";
import PreQuote from "./PreQuote.js";
import SlideHeader from "../../Header/SlideHeader.js";
import { manufacturerLogo, setDefaultValuesOnSalesLoginBtnClick } from "../../../redux/reducers/utils.js";
import { getDealerStateList } from "../../../action/manufacturers_auth/manufacture.action.js";
import ZipInputField from "./ZipInputField.js";

const zipLength = 5;
const State = () => {
	const dispatch = useDispatch();
	const [device, setDevice] = useState(false);
	const [editZipUpdate, setEditZipUpdate] = useState(false);
	const [logoUrl, setLogoUrl] = useState("");
	const [isValidKey, setIsValidKey] = useState(undefined);
	const inputRef = useRef(null);
	const {const_var,params} = useSelector((state) => state.reducer);
	const thankYouForSaveLater = useSelector((state) => state.quoteReducer.quoteState);
	const selectedTabstate = useSelector((state) => state.reducer.selectedTabstate);

	// ################ Variable used to show state dropdown ###################
	let showStateSel = false;
	// ################ Variable true when is_zipcode_screen is true in Crm-Setting otherwise false ################
	let isZipScreenEnable = const_var.crmSetting?.is_zipcode_screen == true ? true : false;
	if (isZipScreenEnable == true && const_var?.is_State_Edit == true && const_var?.state_mfg_zipcode && const_var?.tempZCode == "") {
		const_var.tempZCode = const_var.state_mfg_zipcode;
	}

	// ################ set zip input value ################
	useEffect(() => {
		if (isZipScreenEnable && (const_var?.resetVal === true || (const_var?.is_State_Edit === true && const_var?.state_mfg_zipcode)) && editZipUpdate === false) {
			setZipInputValue();
		}
	}, [const_var.resetVal, const_var.is_State_Edit, const_var.state_mfg_zipcode]);

	// ################ close thank you modal ################
	useEffect(() => {
		if (thankYouForSaveLater === true) {
			dispatch(setThankYouForSaveLaterValue(false));
		}
	}, [thankYouForSaveLater]);

	// ################ show state selector ################
	if (
		isZipScreenEnable == true &&
		(const_var?.showStateZip || (const_var?.is_State_Edit && const_var?.hodldEditBuildingData && (!const_var?.hodldEditBuildingData || !const_var?.hodldEditBuildingData?.state_mfg_zipcode)))
	) {
		showStateSel = true;
	}

	// ################ call api control ################
	let callApifun = true;
	if (!isZipScreenEnable && const_var.stateChangeflag !== "" && const_var.stateChangeflag === params.p_s_n) {
		callApifun = false;
	}
	if (const_var.stateMenuChangeflag !== params.m_s_n) {
		callApifun = true;
	}

	// ################ user data ################
	const isUserData = localStorage.getItem("userData") ? true : false;

	// ################ auto manufacturer selection ################
	useEffect(() => {
		const manufacturer_list = const_var?.bjDData[0]?.manufacturer_list;
		const hasValidManufacturer = (Array.isArray(manufacturer_list) && manufacturer_list.length > 0) || !Array.isArray(manufacturer_list);
		if (const_var.crmSetting.is_Edit != true && const_var.bjDData.length == 1 && hasValidManufacturer && !const_var.isFromPickThis) {
			const data = const_var.bjDData[0];
			if (const_var?.crmSetting.pre_quote_form == true && const_var?.loginSession == false && const_var?.showStateField == false && const_var?.showStateOnly == false) {
				params.p_s_n = data.id;
				params.m_s_n = data?.manufacturer_list?.[0]?.id;
				dispatch(stateManufacturerChange(params.p_s_n, "state"));
			} else {
				if (isZipScreenEnable == true && const_var.loginSession == true && params.m_s_n != "") {
				} else {
					if (isZipScreenEnable == true && const_var.loginSession == false) {
						params.p_s_n = const_var.bjDData[0].id;
						// params.m_s_n = const_var.bjDData[0].manufacturer_list.id;
						params.m_s_n = const_var.bjDData[0]?.manufacturer_list[0].id;
						dispatch(stateManufacturerChange(params.p_s_n, "state"));
					} else {
						params.p_s_n = const_var.bjDData[0].id;
						// params.m_s_n = (isUserData)?const_var.bjDData[0].manufacturer_list[0].id:const_var.bjDData[0].manufacturer_list.id;
						params.m_s_n = isUserData ? const_var.bjDData[0]?.manufacturer_list[0].id : const_var.bjDData[0]?.manufacturer_list[0].id;
						dispatch(stateManufacturerChange(params.p_s_n, "state"));
						if (const_var.crmSetting.is_zipcode_screen == undefined || !const_var.crmSetting.is_zipcode_screen) {
							const_var.confirmState = true;
							// props.getBuildingData(params);
							dispatch(getManufactureDetails(params.manufactureKey, true));
						}
					}
				}
			}
		}
	}, [const_var.bjDData]);

	// ################ logo logic ################
	let dynamicLogo = logoUrl;
	let logoIMG = window.location.origin + "/logo.svg";
	if (const_var.loginSession === true && dynamicLogo) {
		logoIMG = dynamicLogo;
	} else {
		logoIMG = window.location.origin + "/logo.svg";
	}

	// ################ show manufacturer fields ################
	let showManufacturerFields = true;
	if (isZipScreenEnable) {
		if (
			(isUserData || const_var.loginSession == true) &&
			((const_var?.is_State_Edit == true && const_var?.editAPIDataByResponse?.data && const_var?.editAPIDataByResponse?.data?.created_at > "2023-12-13") ||
				const_var?.state_mfg_zipcode?.length == 5 ||
				showStateSel == true)
		) {
			showManufacturerFields = true;
		} else {
			showManufacturerFields = false;
		}
	}

	if (const_var.crmSetting.is_CRM == true && const_var.loginSession == true) {
		showManufacturerFields = true;
	}
	if (const_var.crmSetting.is_CRM == false && const_var.loginSession == true) {
		showManufacturerFields = true;
	}
	if (const_var.crmSetting.is_CRM == false && const_var.loginSession == false && const_var.isZipcodeIncluded != undefined && const_var.isZipcodeIncluded == true) {
		showManufacturerFields = true;
	}
	if (showStateSel == true) {
		showManufacturerFields = true;
	}
	let bottomHighlightedText = "Sensei 3D ";
	let bottomText = "sets the standard for how dreaming and designing metal buildings should feel - intuitive, full of options, and realistic.";
	// if(const_var.crmSetting.main_domain_url!=undefined && const_var.crmSetting.main_domain_url == 'steelbuildingsandstructures.com'){
	//    bottomHighlightedText =  'SBS - Sensei 3D'
	//    bottomText = 'sets the standard for how dreaming and designing metal buildings should feel - intuitive, full of options, and realistic.'
	// }
	if (const_var.crmSetting.main_domain_url != undefined && const_var.crmSetting.main_domain_url == "safeguardmetalbuildings.com") {
		bottomHighlightedText = "";
		bottomText = "A premier supplier of Carports, Garages, Metal Barns, and Steel Buildings";
	}
	if (const_var.crmSetting.main_domain_url != undefined && const_var.crmSetting.main_domain_url == "custombuiltstructures.com") {
		bottomHighlightedText = "";
		bottomText = "Your Premier Steel Building Choice";
	}
	if (const_var.crmSetting.main_domain_url != undefined && const_var.crmSetting.main_domain_url == "aametalbuildings.com") {
		bottomHighlightedText = "";
		bottomText = "America" + "'s" + "#1 Dealer of Custom Metal Buildings. YOU WANT IT. WE GOT IT";
	}
	if (const_var.crmSetting.main_domain_url != undefined && const_var.crmSetting.main_domain_url == "americanmetalbuildings.com") {
		bottomHighlightedText = "";
		bottomText = "American Metal Buildings offers extremely versatile metal buildings and steel structures across the USA";
	}
	if (const_var.crmSetting.main_domain_url != undefined && const_var.crmSetting.main_domain_url == "eaglebuildings.com") {
		bottomHighlightedText = "";
		bottomText = "Our mission is to provide you with seamless experience, ensuring that every aspect of your metal building project is handled with the utmost care and precision";
	}
	if (const_var.crmSetting.main_domain_url != undefined && const_var.crmSetting.main_domain_url == "fivestarmetalbuildings.com") {
		bottomHighlightedText = "";
		bottomText = "We Build Great Buildings";
	}

	// ################ design button disable ################
	let isBtnDisabled = false;

	if (
		isZipScreenEnable == true &&
		(const_var.is_State_Edit == false || const_var.is_State_Edit == true) &&
		showStateSel == false &&
		(const_var.state_mfg_zipcode == "" ||
			const_var.state_mfg_zipcode.length != 5 ||
			const_var.ziperrormsg ||
			const_var.displayerrorMessage?.zipcode ||
			const_var.SApiCalled == undefined ||
			const_var.SApiCalled == false)
	) {
		isBtnDisabled = true;
	}
	if ((isZipScreenEnable == false || showStateSel == true) && (params.p_s_n == "" || params.p_s_n == 0) && (params.m_s_n == "" || params.m_s_n == 0)) {
		isBtnDisabled = true;
	}
	if (
		(isZipScreenEnable == true && const_var.state_mfg_zipcode != "" && const_var.state_mfg_zipcode.length != 5) ||
		(showStateSel == true && (params.p_s_n == "" || params.p_s_n == 0) && (params.m_s_n == "" || params.m_s_n == 0))
	) {
		isBtnDisabled = true;
	}
	if (isZipScreenEnable == true && const_var.SApiCalled == true && const_var?.isZipcodeIncluded == false && const_var.showStateZip == false && const_var.crmSetting.is_CRM == true) {
		isBtnDisabled = true;
	}
	if (const_var.is_loader) {
		isBtnDisabled = true;
	}

	//################ Condition on keydown ################
	const checkKeyValue = (e, isLastIdx, isBtnDisabled, showStateSel) => {
		// ################################### condition to restrict when user press arrow(up/down/left/right) or press +,-,/,* or press enter on last digit but design button is disabled or press enter on before last digit ###################################
		if (
			(const_var.showReportLoading != undefined && const_var.showReportLoading == true) ||
			e.keyCode == 38 ||
			e.keyCode == 40 ||
			e.keyCode == 37 ||
			e.keyCode == 39 ||
			e.keyCode == 107 ||
			e.keyCode == 109 ||
			e.keyCode == 187 ||
			e.keyCode == 189 ||
			e.keyCode == 111 ||
			e.keyCode == 106 ||
			((e.keyCode == 13 || e.keyCode == 9) &&
				(isLastIdx == undefined || (isLastIdx != undefined && isLastIdx == true && ((isBtnDisabled != undefined && isBtnDisabled == true) || (showStateSel != undefined && showStateSel == true)))))
		) {
			e.preventDefault();
			setIsValidKey(false);
		} else {
			setIsValidKey(true);
		}
	};
	const inputfocus = (elmnt, isLastIdx, isBtnDisabled, showStateSel, firstinputkey) => {
		if (const_var?.is_State_Edit) {
			setEditZipUpdate(true);
		}
		// ################################### condition to restrict when user press arrow(up/down/left/right) or press +,-,/,* or press enter on last digit but design button is disabled or press enter on before last digit ###################################
		if (
			elmnt.key == "Control" ||
			elmnt.keyCode == 37 ||
			elmnt.keyCode == 39 ||
			elmnt.keyCode == 38 ||
			elmnt.keyCode == 40 ||
			elmnt.keyCode == 107 ||
			elmnt.keyCode == 109 ||
			elmnt.keyCode == 187 ||
			elmnt.keyCode == 189 ||
			elmnt.keyCode == 111 ||
			elmnt.keyCode == 106 ||
			((elmnt.keyCode == 13 || elmnt.keyCode == 9) &&
				(isLastIdx == undefined || (isLastIdx != undefined && isLastIdx == true && ((isBtnDisabled != undefined && isBtnDisabled == true) || (showStateSel != undefined && showStateSel == true)))))
		) {
			return;
		}
		if (isValidKey == true) {
			elmnt.preventDefault();
			// return;
		}
		const inputElements = [...document.querySelectorAll("input.zipInput")];
		const finalzipvalue = inputElements.map(({ value }) => value).join("");
		// ################################### condition to restrict when user press any same digit multitime ###################################
		if (const_var.tempZCode === finalzipvalue && const_var.tempZCode.length == 5 && finalzipvalue.length == 5) {
			return;
		}
		const_var.zipManufErrMsg = "";
		// ################################### reset values on zipcode change ###################################
		if (const_var.showStateZip == true) {
			const_var.showStateZip = false;
			params.p_s_n = "";
			params.m_s_n = "";
		}
		// const inputElements = [...document.querySelectorAll('input.zipInput')]
		// const finalzipvalue = inputElements.map(({value})=>value).join('')
		zipinputvaluefocus(elmnt);
		// ################################### reset values on zipcode change ###################################
		if (const_var.ziperrormsg != undefined && const_var.ziperrormsg != "" && finalzipvalue != const_var.tempZCode) {
			dispatch(zipCodeError(""));
			dispatch(showStateField(false, false));
		}
		if (elmnt.key === "Delete" || elmnt.key === "Backspace") {
			const_var.showStateZip = false;
			// const next  = elmnt.target.tabIndex - 1;
			// // const finalzipvalue = inputElements.map(({value})=>value).join('')
			// if (next > -1) {
			//    if(const_var.tempZCode.charAt(elmnt.target.tabIndex) == ''){
			//       inputElements[next].value = ''
			//    }

			//    elmnt.target.form.elements[next].focus()
			const_var.tempZCode = finalzipvalue;
			const_var.SApiCalled = false;
			validate.onTextFiledChangeValue(finalzipvalue, "zipcode", "Zip Code");
			// }
			if (finalzipvalue.length == 5) {
				setZipCode(finalzipvalue);
			} else {
				dispatch(setZipCodeVal(finalzipvalue, "statemanufacturechangepage"));
			}
		} else {
			// const finalzipvalue = inputElements.map(({value})=>value).join('')
			const next = elmnt.target.tabIndex;
			if (next < 4) {
				if (elmnt.target.form.elements[next].value != "" && /[0-9]/.test(parseInt(elmnt.target.form.elements[next].value))) {
					elmnt.target.form.elements[next + 1].focus();
				}

				validate.onTextFiledChangeValue(finalzipvalue, "zipcode", "Zip Code");
				const_var.SApiCalled = false;
				if (finalzipvalue.length == 5) {
					setZipCode(finalzipvalue);
				} else {
					dispatch(setZipCodeVal(finalzipvalue, "statemanufacturechangepage"));
				}
			}
			// if (elmnt.keyCode === 13 && next == 4 && const_var.SApiCalled != undefined && const_var.SApiCalled == true && (const_var.zipManufErrMsg == undefined || const_var.zipManufErrMsg == '' || const_var.zipManufErrMsg == null) && (
			//    const_var.ziperrormsg == undefined || const_var.ziperrormsg == '' || const_var.ziperrormsg == null
			// )) {
			//    if( document.querySelector('.zip-mfg-btn')){
			//       document.querySelector('.zip-mfg-btn').click();
			//    }
			// }
			if (
				next == 4 &&
				(const_var.tempZCode.charAt(elmnt.target.tabIndex) == "" ||
					parseInt(const_var.tempZCode.charAt(elmnt.target.tabIndex)) != parseInt(finalzipvalue.charAt(elmnt.target.tabIndex)) ||
					parseInt(const_var.tempZCode.charAt(elmnt.target.tabIndex - 1)) != parseInt(finalzipvalue.charAt(elmnt.target.tabIndex - 1)))
			) {
				const_var.tempZCode = finalzipvalue;
				if (finalzipvalue.length == 5) {
					setZipCode(finalzipvalue);
				}
			}
		}
	};
	// ################ setZipInputValue ################
	const setZipInputValue = (zipCode) => {
		let zip_code = zipCode || zipCode == "" ? zipCode : const_var.state_mfg_zipcode;
		const inputElements = [...document.querySelectorAll("input.zipInput")];
		if (zip_code != "") {
			const allzipvalue = Array.from(String(zip_code), Number);
			inputElements.forEach((ele, index) => {
				if (allzipvalue[index] != undefined) {
					ele.value = allzipvalue[index];
				}
			});
			const_var.resetVal = false;
		} else {
			inputElements.forEach((ele, index) => {
				ele.value = "";
			});
			const_var.resetVal = false;
		}
	};
	const handleBtnClick = async () => {
		const stateId = params.p_s_n;
		const selectedState = const_var.bjDData.find((state) => state.id == stateId);
		if (selectedState && !const_var.loginSession && selectedState?.manufacturer_list[0]?.price_comparision?.length > 0) {
			const key = `selectedState_${stateId}`;
			let mfgList = [...selectedState?.manufacturer_list, ...selectedState?.manufacturer_list[0]?.price_comparision];

			dispatch(savePriceComparisionDataForNotLoggedIn(key, mfgList));
		}
		// props.getBuildingData(params,'direct')
		dispatch(getManufactureDetails(params.manufactureKey, true));
	};
	// ################ setZipCode ################
	const setZipCode = (finalzipvalue) => {
		validate.onTextFiledChangeValue(finalzipvalue, "zipcode", "Zip Code");
		dispatch(setZipCodeVal(finalzipvalue, "statemanufacturechangepage"));
		dispatch(getDealerStateList(false, true, finalzipvalue));
	};

	const salesLogin = () => {
		dispatch(setZipCodeVal("", "statemanufacturechangepage"));
		setDefaultValuesOnSalesLoginBtnClick();
		dispatch(getSelectedTabstate("loginstyletab"));
	};

	const submitForm = async (e) => {
		let apiCalled = await dispatch(onSubmit(e, true));
		if (apiCalled && const_var.crmSetting.pre_quote_form == true && const_var.preQuoteApiCalled == true && const_var.preQuoteError == false) {
			// props.getBuildingData(params,'direct');
			dispatch(getManufactureDetails(params.manufactureKey, true));
		}
	};
	// ################ Function calls on state selection and to reset value of zipcode, error msgs
	const setStateSel = (e) => {
		if (const_var.crmSetting.is_zipcode_screen != undefined && const_var.crmSetting.is_zipcode_screen == true) {
			setZipInputValue("");
			const_var.state_mfg_zipcode = "";
			const_var.tempZCode = "";
			const_var.ziperrormsg = "";
			const_var.displayerrorMessage = {};
			const_var.checkValidatePattern = false;
		}
		dispatch(stateManufacturerChange(e.target.value, "state"));
	};

	// ################  Paste function for Zipcode ################
	const pastedata = (evt) => {
		const pastedData = evt.clipboardData.getData("text/plain");
		let checkvaluetypnumber = parseFloat(pastedData, evt);
		if (isNaN(checkvaluetypnumber)) {
			return;
		}
		let pastedataarray = pastedData.toString().split("");
		if (pastedataarray.length > 5) {
			pastedataarray.splice(5);
		}
		const inputElements = [...document.querySelectorAll("input.zipInput")];
		pastedataarray.forEach((data, index) => {
			const emptyInput = inputElements.find((input) => input.value.trim() === "");
			if (emptyInput) {
				emptyInput.value = data;
				emptyInput.focus();
			}
		});
		evt.preventDefault();
	};
	// ################ zipinputvaluefocus ################
	const zipinputvaluefocus = (event) => {
		if (
			(const_var.showReportLoading != undefined && const_var.showReportLoading == true) ||
			event.keyCode == 38 ||
			event.keyCode == 40 ||
			event.keyCode == 37 ||
			event.keyCode == 39 ||
			event.keyCode == 13 ||
			event.keyCode == 107 ||
			event.keyCode == 109 ||
			event.keyCode == 187 ||
			event.keyCode == 189 ||
			event.keyCode == 13
		) {
			event.preventDefault();
			return;
		}
		const inputElements = [...document.querySelectorAll("input.zipInput")];
		inputElements.forEach((ele, index) => {
			ele.addEventListener("keydown", (e) => {
				if (e.keyCode === 8 && e.target.value === "") {
					inputElements[Math.max(0, index - 1)].focus();
				}
			});
			ele.addEventListener("input", (e) => {
				const [first, ...rest] = e.target.value;
				e.target.value = first ?? "";
				const lastInputBox = index === inputElements.length - 1;
				const didInsertContent = first !== undefined;
				if (didInsertContent && !lastInputBox) {
					inputElements[index + 1].focus();
				}
			});
		});
	};

	useEffect(() => {
		if (const_var.crmSetting.is_zipcode_screen != undefined && const_var.crmSetting.is_zipcode_screen == true) {
			if (window.innerWidth <= 992) {
				setDevice(true);
			}
			window.addEventListener("resize", () => {
				if (window.innerWidth <= 992) {
					setDevice(true);
				} else {
					setDevice(false);
				}
			});
			setZipInputValue();
		}
		manufacturerLogo().then((url) => {
			if (url) {
				setLogoUrl(url);
			}
		});
	}, []);
	return (
		<div className="srb-cange-box for-top-fix-box">
			{/*   <div className='state-video-sec'>

<video muted loop autoPlay poster={StateVideoCover} >
<source src={StateVideo} type="video/mp4"/>
</video>
</div>
*/}

			<div className="srb-overlay d-none"></div>

			<div className="srb-cange-box-inner changestate-box">
				{(const_var.loginSession == true || localStorage.getItem("userData") != undefined || localStorage.getItem("userData") != null) && selectedTabstate == "statechange" && <SlideHeader />}

				<div className="momenent"> </div>

				<div
					className={`${const_var.crmSetting.pre_quote_form == true && const_var.loginSession == false && isUserData == false ? "pre-quote-wrapper" : "state-wrapper "}`}
					style={{
						backgroundImage: `url(${
							const_var.crmSetting.main_domain_url !== undefined && const_var.crmSetting.main_domain_url === "garagebuildings.com"
								? "https://cdn.sensei3d.com/static/media/garagebuildings.d1a92a99.png"
								: const_var.crmSetting.state_screen_bg_image_type_two !== undefined
									? "https://cdn.sensei3d.com/static/media/img-a.7d466d21.png"
									: const_var.crmSetting.main_domain_url == "eaglebuildings.com"
										? "https://cdn.sensei3d.com/static/media/eaglebuildings_img.f6c182d3.png"
										: const_var.crmSetting.main_domain_url !== undefined && const_var.crmSetting.main_domain_url == "custombuiltstructures.com"
											? "https://cdn.sensei3d.com/static/media/CustomBuilt_bg.359c5d7e.png"
											: const_var.crmSetting.main_domain_url !== undefined && const_var.crmSetting.main_domain_url == "fivestarmetalbuildings.com"
												? "https://cdn.sensei3d.com/static/media/fivestarmetalbuildings_bg.359c5d7e.png"
												: const_var.crmSetting.main_domain_url == "carportx.com"
													? "https://cdn.sensei3d.com/static/media/carportx_img-a.7d466d21.png"
													: "https://cdn.sensei3d.com/static/media/new-bg.14dd4039.png"
						})`
					}}
				>
					{const_var.crmSetting.pre_quote_form == true && const_var.loginSession == false && isUserData == false ? (
						<PreQuote submitForm={submitForm} logoIMG={logoIMG} callApifun={callApifun} />
					) : (
						<>
							{
								<form
									className={"container" + (const_var.showReportLoading != undefined && const_var.showReportLoading == true ? " form-submiting" : "")}
									onSubmit={(e) => {
										e.preventDefault();
										if (!isBtnDisabled) {
											dispatch(onSubmitState(e));
										}
									}}
								>
									<div className={"state-all-content" + (const_var.loginSession == true || isUserData == true ? " " : " more-ht")}>
										<div className="state-change-top">
											<div className="state-text-content">
												{(const_var.loginSession == true || isUserData == true) && const_var.crmSetting.is_loggedin == true ? (
													<div className={"back-to-crm-state-wrapper" + (isZipScreenEnable == true ? " back-to-zip" : "")}>
														{
															(const_var.crmSetting.is_CRM = !true ? (
																<a href={const_var.crmSetting.web_url} className="back-to-crm-state">
																	<span className="icon-arrow-s2 icon"></span>
																	<span className="text">Back To CRM</span>
																</a>
															) : null)
														}
													</div>
												) : (
													""
												)}
												<div className={"state-text-logo" + (const_var.crmSetting.main_domain_url == "americansteelinc.com" ? " state-text-logo-inc" : "")}>
													<img src={logoIMG} className="mfg_zip_big_logo" />
													{/* <img src={logoIMG} className={(const_var.crmSetting.mfg_zip_big_logo != undefined && const_var.crmSetting.mfg_zip_big_logo == true ? ' mfg_zip_big_logo' : '')} /> */}
												</div>
												{isZipScreenEnable == false ? (
													<>
														{const_var.crmSetting.main_domain_url != "Walkerbuildings.com" ? (
															<>
																{const_var.crmSetting.main_domain_url == "customstructuresdirect.com" ? (
																	<div className="span-1">DESIGN IT. BUILD IT. LOVE IT.</div>
																) : (
																	<div className="span-1">Dream, Design, Discuss</div>
																)}
																<div className="span-3">Let’s get started.</div>
															</>
														) : (
															<div className="for-big-span-text">
																<div className="span-1">Redefining the Building Experience</div>

																<div className="span-3">Start here.</div>
															</div>
														)}
													</>
												) : (
													<p>
														{(const_var.is_State_Edit != undefined &&
															const_var.is_State_Edit == true &&
															const_var.editAPIDataByResponse.data != undefined &&
															const_var.editAPIDataByResponse.data.created_at <= "2023-12-13") ||
														showStateSel == true ? (
															<>
																Choose Your <span className="highlighted-text text-bold">State</span> for Installation
															</>
														) : (
															<>
																Provide Your <span className="highlighted-text text-bold">ZIP code</span> for pricing & delivery
															</>
														)}
													</p>
												)}
												{/* <div className='span-3'>
                              Let’s get started.
                           </div> */}
											</div>
											<div className={"state-content-input-wrap" + (isZipScreenEnable == false ? " state-only" : "")}>
												{isZipScreenEnable == true &&
													((const_var.is_State_Edit != undefined &&
														const_var.is_State_Edit == true &&
														const_var.editAPIDataByResponse.data != undefined &&
														const_var.editAPIDataByResponse.data.request_data.building.state_mfg_zipcode != undefined &&
														const_var.editAPIDataByResponse.data.request_data.building.state_mfg_zipcode != "" &&
														const_var.editAPIDataByResponse.data.request_data.building.state_mfg_zipcode != null) ||
														const_var.is_State_Edit != true) && (
														<div className="row">
															<div
																className={`col-12 mt-0 ${(const_var.displayerrorMessage.zipcode == "" || const_var.displayerrorMessage.zipcode == undefined) && (const_var.ziperrormsg == "" || const_var.ziperrormsg == undefined) ? "floating-label-input" : "floating-label-input invalid-input"}`}
																style={{ marginBottom: "20px" }}
															>
																<div className="zipContainer">
																	{Array.from({ length: zipLength }).map((__, index) => {
																		return (
																			<ZipInputField
																				key={`zip${index}`}
																				name={`zip${index + 1}`}
																				type={device == true ? "tel" : "number"}
																				autoComplete={"off"}
																				inputRef={index === 0 ? inputRef : null}
																				tabIndex={index}
																				maxLength="1"
																				onPaste={(evt) => pastedata(evt)}
																				autoFocus={index === 0}
																				onKeyUp={(e) => {
																					index === zipLength - 1 ? inputfocus(e, true, isBtnDisabled, showStateSel) : inputfocus(e);
																				}}
																				onKeyDown={(e) => {
																					if (index === 0) zipinputvaluefocus(e);
																					else if (index === zipLength - 1) checkKeyValue(e, true, isBtnDisabled, showStateSel);
																					else checkKeyValue(e);
																				}}
																			/>
																		);
																	})}
																</div>
																{const_var?.displayerrorMessage?.zipcode ? (
																	<div className="errorMessageStatePage" id="zcodeErrorMessage" style={{ margin: "10px 0px -15px 0px" }}>
																		{const_var.displayerrorMessage.zipcode}
																	</div>
																) : (
																	<>
																		{const_var.ziperrormsg != undefined && const_var.ziperrormsg != "" && (
																			<div className="errorMessageStatePage" id="zcodeErrorMessage1" style={{ margin: "10px 0px -15px 0px" }}>
																				{const_var.ziperrormsg}
																			</div>
																		)}
																	</>
																)}
																{const_var.isZipcodeIncluded != undefined &&
																	const_var.isZipcodeIncluded == false &&
																	const_var.showStateZip == false &&
																	const_var.zipManufErrMsg != undefined &&
																	const_var.zipManufErrMsg != "" &&
																	const_var.loginSession == false && (
																		<div className={const_var.zipErrorMsgFlag == true ? "errorMessageZipExistStatePage" : "errorMessageZipExistStatePage success"}>
																			{const_var.zipManufErrMsg}
																		</div>
																	)}
															</div>
														</div>
													)}
												{/*  ############ User company selction component ############## : Start : */}
												{const_var.isFromSalesLogin == true && const_var.loginSession == true && const_var.userCompanies && const_var.userCompanies.length > 1 && (
													<div className="floating-label-input floating-label-inside text-left login-select">
														{
															<>
																<Select
																	onChange={(e) => dispatch(handleCompanySelection(e.target.value, "state"))}
																	value={params.company_id === "" ? "Select" : params.company_id}
																	className="cpanelselect"
																	label="Company"
																	id="threed_state_change"
																	ripple="RipplePropF"
																	// defaultValue={{ label: "Select", value: "Select" }}
																	options={[
																		// { label: "Select", value: "Select" }, // Keep "Select" as the first option
																		...const_var.userCompanies
																			?.filter((val) => val.company_name !== "Select")
																			.sort((a, b) => a.company_name.localeCompare(b.company_name))
																			?.map((val) => ({
																				value: val.company_id,
																				label: val.company_name
																			}))
																	]}
																/>
															</>
														}
													</div>
												)}
												{/*  ############ User company selction component ############## : END : */}
												{(isZipScreenEnable == false ||
													(const_var.is_State_Edit != undefined &&
														const_var.is_State_Edit == true &&
														const_var.editAPIDataByResponse.data != undefined &&
														const_var.editAPIDataByResponse.data.created_at <= "2023-12-13") ||
													showStateSel == true) && (
													<div className="floating-label-input floating-label-inside text-left login-select">
														{
															<>
																{const_var.bjD.length != undefined && const_var.bjD.length > 0 ? (
																	<Select
																		disabled={const_var.is_loader == true}
																		onChange={(e) => setStateSel(e, "state")}
																		value={params.p_s_n === "" ? "Select" : params.p_s_n}
																		className="cpanelselect"
																		label="State"
																		id="threed_state_change"
																		ripple="RipplePropF"
																		defaultValue={{ label: "Select", value: "Select" }}
																		options={[
																			{ label: "Select", value: "Select" }, // Keep "Select" as the first option
																			...const_var.bjD
																				.filter((val) => val.name !== "Select")
																				.sort((a, b) => a.name.localeCompare(b.name))
																				.map((val) => ({
																					value: val.id,
																					label: val.name
																				}))
																		]}
																	/>
																) : null}
															</>
														}
													</div>
												)}
												{showManufacturerFields && const_var.stateManufacturerAcordingAPI[params.p_s_n] != undefined && const_var.stateManufacturerAcordingAPI[params.p_s_n].length > 0 && (
													<>
														<label className="choose-label d-none">Choose Your State for Installation</label>
														{const_var.loginSession == true || isUserData == true ? (
															<div className={params.p_s_n != "" ? "" : "d-none"}>
																{const_var.stateManufacturerAcordingAPI[params.p_s_n] != undefined &&
																const_var.MFApiCalled == true &&
																(const_var.loginSession == true || isUserData == true) ? (
																	<div className="position-relative">
																		<div className="floating-label-input floating-label-inside text-left manuf-sel-block login-select">
																			<Select
																				className="cpanelselect"
																				label="Manufacturer (To Price)"
																				id="threed_manufacturer_change"
																				onChange={(e) => dispatch(stateManufacturerChange(e.target.value, "manufacturer"))}
																				ripple="RipplePropF"
																				value={params.m_s_n}
																				defaultValue={{ label: "Select", value: "Select" }}
																				options={const_var.stateManufacturerAcordingAPI[params.p_s_n].map((val, index) => {
																					return { value: val.id, label: val.name };
																				})}
																			/>
																			{/* {
                                                   const_var.isZipcodeIncluded != undefined && const_var.isZipcodeIncluded == 0 && const_var.showStateZip == false &&
                                                   <div className="not-serve-errmsg">Not serve at this state</div>
                                                } */}
																		</div>

																		{const_var.isZipcodeIncluded != undefined &&
																			const_var.isZipcodeIncluded == false &&
																			const_var.showStateZip == false &&
																			const_var.zipManufErrMsg != undefined &&
																			const_var.zipManufErrMsg != "" && (
																				<div className={const_var.zipErrorMsgFlag == true ? "errorMessageZipExistStatePage" : "errorMessageZipExistStatePage success"}>
																					{const_var.zipManufErrMsg}
																				</div>
																			)}
																	</div>
																) : null}
															</div>
														) : null}
													</>
												)}
												{isZipScreenEnable == false && (
													<div className={const_var.confirmStateError ? "checkbox invalid-check" : "checkbox"}>
														<Checkbox
															className="secondary"
															ripple="RipplePropF"
															id="threed_remember"
															checked={const_var.confirmState}
															label="Yes, I confirm my state"
															onChange={(e) => dispatch(confirmStateAction(e.target.value))}
														/>
													</div>
												)}
												{const_var.displayerrorMessage.company_id != "" && !const_var?.ziperrormsg && !const_var?.displayerrorMessage?.zipcode && (
													<div className="errorMessageStatePage" id="zcodeErrorMessage" style={{ margin: "10px 0px -15px 0px" }}>
														{const_var.displayerrorMessage.company_id}
													</div>
												)}
												<div className="text-left d-none">
													<span className={const_var.confirmStateError ? "what-this ml-0" : "what-this d-none ml-0"}>Please confirm state</span>
												</div>
												<div className="change-state-cta" style={{ marginTop: showStateSel != true && showManufacturerFields != true ? "50px" : "0px" }}>
													<button
														id="threed_proced-cta"
														onClick={() => {
															if ((isZipScreenEnable != true && const_var.confirmState == true) || isZipScreenEnable == true)
																if (callApifun === false) {
																	dispatch(getSelectedTabstate("buildingtypetab"));
																} else {
																	if (isBtnDisabled != true) {
																		document.querySelector("body").classList.add("active-modal-loader");

																		handleBtnClick();
																	}
																}
														}}
														className={isBtnDisabled == true ? "btn btn-solid btn-block disabled" : "btn btn-solid btn-block zip-mfg-btn"}
													>
														{isZipScreenEnable == true &&
														const_var.isZipcodeIncluded != undefined &&
														const_var.isZipcodeIncluded == false &&
														const_var.showStateZip == false &&
														const_var.zipManufErrMsg != undefined &&
														const_var.zipManufErrMsg != "" &&
														const_var.loginSession == false &&
														const_var.crmSetting.main_domain_url != "premiumbuildingsusa.com" ? (
															// (const_var.loginSession==false || (const_var.SApiCalled == true && const_var.crmSetting.is_CRM != true && const_var.loginSession == true && isUserData == true)) ?
															<span className="text">Design w/o price</span>
														) : (
															<span className="text">Design</span>
														)}
														<span className="saving-effect">
															<span></span>
															<span></span>
															<span></span>
														</span>
													</button>
												</div>
											</div>
										</div>
										<div className={const_var.confirmState ? "change-state-footer " : "change-state-footer"}>
											{const_var.loginSession == false && isUserData == false && const_var.crmSetting.is_loggedin == true ? (
												<>
													<div className="click-login-wrap">
														Click here for{" "}
														<a href onClick={() => salesLogin()}>
															{const_var.crmSetting.parent_api_token == "Fq6Meq4bloS4c7Pqj7OuVNHfiPhWnuesTwy3KiuFNCJ2cyu3WKIGEFqc74qsprei" ||
															const_var.crmSetting.parent_api_token == "P0pjF0vzahFWP8DTFzQulTkOFi5b2cpoeNrLSxIMXxgMRe0fpAYKRpFRLCPvC9ke"
																? "Dealer Login"
																: "Sales Login"}
														</a>
													</div>
												</>
											) : (
												""
											)}
											{const_var.crmSetting.main_domain_url != undefined && const_var.crmSetting.main_domain_url == "steelbuildingsandstructures.com" ? (
												<div className="span-text btm-bold-text">THE COMPANY THAT BUILDS WITH PRIDE</div>
											) : (
												<div className="span-text">
													<span className="highlighted-text text-bold">{bottomHighlightedText}</span>
													{bottomText}
													{params.m_s_n == 13 || const_var.crmSetting.main_domain_url == "tubularbuildingsystems.com" ? (
														<>
															<label style={{ background: "#ffc2003b", padding: "5px", marginTop: "5px", borderRadius: "2px", fontStyle: "italic" }}>
																*Binding quotes and sales contracts are generated through contact with one of our sales representatives.
															</label>
														</>
													) : (
														""
													)}
												</div>
											)}
										</div>
									</div>
								</form>
							}
						</>
					)}
				</div>
			</div>
		</div>
	);
};

export default State;
